import { motion } from "framer-motion";
import { manifesto } from "@/data";
import { fadeUp, viewport } from "@/lib/motion";

const Manifesto = () => {
  return (
    <section id="how" className="relative py-24 md:py-32" data-testid="manifesto">
      <div className="max-w-7xl mx-auto px-5 md:px-8">
        <motion.div variants={fadeUp} initial="hidden" whileInView="show" viewport={viewport} className="mb-16 md:mb-24 max-w-3xl">
          <p className="text-[#ccff00] text-xs font-semibold uppercase tracking-widest mb-4">The business-in-a-box</p>
          <h2 className="font-display font-black tracking-tighter text-4xl md:text-5xl lg:text-6xl leading-tight">
            You talk. We build. You launch.
          </h2>
          <p className="text-lg text-zinc-400 mt-6 max-w-2xl">
            No WordPress. No hosting headaches. No DNS, plugins or six-week timelines. Three simple steps
            between you and a business that looks like it's been established for years.
          </p>
        </motion.div>

        <div className="grid md:grid-cols-3 gap-px bg-white/10 rounded-2xl overflow-hidden border border-white/10">
          {manifesto.map((m, i) => (
            <motion.div
              key={m.n}
              variants={fadeUp}
              initial="hidden"
              whileInView="show"
              viewport={viewport}
              transition={{ delay: i * 0.12 }}
              className="bg-[#0b0b0b] p-8 md:p-10 relative group hover:bg-[#111] transition-colors"
              data-testid={`manifesto-step-${m.n}`}
            >
              <span className="font-display font-black text-6xl md:text-7xl text-transparent [-webkit-text-stroke:1px_rgba(204,255,0,0.4)] group-hover:[-webkit-text-stroke:1px_rgba(204,255,0,0.9)] transition-all">
                {m.n}
              </span>
              <h3 className="font-display font-bold text-2xl md:text-3xl mt-6 mb-4">{m.title}</h3>
              <p className="text-zinc-400 leading-relaxed">{m.body}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Manifesto;
